function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _styled from "@emotion/styled/base";
import _isEmpty from "lodash/isEmpty";

function cov_dt62d3vlu() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_SingleLineInput.tsx";
  var hash = "a256b29bbb9382fb3851d0135201bbc1ee33579b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_SingleLineInput.tsx",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 30
        },
        end: {
          line: 22,
          column: 59
        }
      },
      "1": {
        start: {
          line: 126,
          column: 45
        },
        end: {
          line: 131,
          column: 1
        }
      },
      "2": {
        start: {
          line: 127,
          column: 23
        },
        end: {
          line: 127,
          column: 62
        }
      },
      "3": {
        start: {
          line: 133,
          column: 33
        },
        end: {
          line: 149,
          column: 1
        }
      },
      "4": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 142,
          column: 5
        }
      },
      "5": {
        start: {
          line: 139,
          column: 6
        },
        end: {
          line: 139,
          column: 31
        }
      },
      "6": {
        start: {
          line: 140,
          column: 11
        },
        end: {
          line: 142,
          column: 5
        }
      },
      "7": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 40
        }
      },
      "8": {
        start: {
          line: 144,
          column: 4
        },
        end: {
          line: 144,
          column: 38
        }
      },
      "9": {
        start: {
          line: 147,
          column: 23
        },
        end: {
          line: 147,
          column: 78
        }
      },
      "10": {
        start: {
          line: 151,
          column: 36
        },
        end: {
          line: 157,
          column: 1
        }
      },
      "11": {
        start: {
          line: 159,
          column: 35
        },
        end: {
          line: 161,
          column: 1
        }
      },
      "12": {
        start: {
          line: 163,
          column: 34
        },
        end: {
          line: 188,
          column: 1
        }
      },
      "13": {
        start: {
          line: 169,
          column: 27
        },
        end: {
          line: 169,
          column: 42
        }
      },
      "14": {
        start: {
          line: 173,
          column: 15
        },
        end: {
          line: 173,
          column: 74
        }
      },
      "15": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 181,
          column: 5
        }
      },
      "16": {
        start: {
          line: 176,
          column: 6
        },
        end: {
          line: 176,
          column: 27
        }
      },
      "17": {
        start: {
          line: 177,
          column: 11
        },
        end: {
          line: 181,
          column: 5
        }
      },
      "18": {
        start: {
          line: 178,
          column: 6
        },
        end: {
          line: 178,
          column: 27
        }
      },
      "19": {
        start: {
          line: 179,
          column: 11
        },
        end: {
          line: 181,
          column: 5
        }
      },
      "20": {
        start: {
          line: 180,
          column: 6
        },
        end: {
          line: 180,
          column: 33
        }
      },
      "21": {
        start: {
          line: 194,
          column: 55
        },
        end: {
          line: 200,
          column: 3
        }
      },
      "22": {
        start: {
          line: 229,
          column: 8
        },
        end: {
          line: 229,
          column: 18
        }
      },
      "23": {
        start: {
          line: 232,
          column: 6
        },
        end: {
          line: 232,
          column: 89
        }
      },
      "24": {
        start: {
          line: 234,
          column: 4
        },
        end: {
          line: 268,
          column: 6
        }
      },
      "25": {
        start: {
          line: 271,
          column: 25
        },
        end: {
          line: 274,
          column: 3
        }
      },
      "26": {
        start: {
          line: 272,
          column: 4
        },
        end: {
          line: 272,
          column: 23
        }
      },
      "27": {
        start: {
          line: 273,
          column: 4
        },
        end: {
          line: 273,
          column: 77
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 127,
            column: 11
          },
          end: {
            line: 127,
            column: 12
          }
        },
        loc: {
          start: {
            line: 127,
            column: 23
          },
          end: {
            line: 127,
            column: 62
          }
        },
        line: 127
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 137,
            column: 15
          },
          end: {
            line: 137,
            column: 16
          }
        },
        loc: {
          start: {
            line: 137,
            column: 26
          },
          end: {
            line: 145,
            column: 3
          }
        },
        line: 137
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 147,
            column: 11
          },
          end: {
            line: 147,
            column: 12
          }
        },
        loc: {
          start: {
            line: 147,
            column: 23
          },
          end: {
            line: 147,
            column: 78
          }
        },
        line: 147
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 169,
            column: 16
          },
          end: {
            line: 169,
            column: 17
          }
        },
        loc: {
          start: {
            line: 169,
            column: 27
          },
          end: {
            line: 169,
            column: 42
          }
        },
        line: 169
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        },
        loc: {
          start: {
            line: 173,
            column: 15
          },
          end: {
            line: 173,
            column: 74
          }
        },
        line: 173
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 174,
            column: 19
          },
          end: {
            line: 174,
            column: 20
          }
        },
        loc: {
          start: {
            line: 174,
            column: 30
          },
          end: {
            line: 182,
            column: 3
          }
        },
        line: 174
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 202,
            column: 2
          },
          end: {
            line: 202,
            column: 3
          }
        },
        loc: {
          start: {
            line: 202,
            column: 31
          },
          end: {
            line: 269,
            column: 3
          }
        },
        line: 202
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 271,
            column: 25
          },
          end: {
            line: 271,
            column: 26
          }
        },
        loc: {
          start: {
            line: 271,
            column: 67
          },
          end: {
            line: 274,
            column: 3
          }
        },
        line: 271
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 127,
            column: 23
          },
          end: {
            line: 127,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 127,
            column: 46
          },
          end: {
            line: 127,
            column: 52
          }
        }, {
          start: {
            line: 127,
            column: 55
          },
          end: {
            line: 127,
            column: 62
          }
        }],
        line: 127
      },
      "1": {
        loc: {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        }, {
          start: {
            line: 140,
            column: 11
          },
          end: {
            line: 142,
            column: 5
          }
        }],
        line: 138
      },
      "2": {
        loc: {
          start: {
            line: 140,
            column: 11
          },
          end: {
            line: 142,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 140,
            column: 11
          },
          end: {
            line: 142,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 140
      },
      "3": {
        loc: {
          start: {
            line: 147,
            column: 23
          },
          end: {
            line: 147,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 147,
            column: 40
          },
          end: {
            line: 147,
            column: 57
          }
        }, {
          start: {
            line: 147,
            column: 60
          },
          end: {
            line: 147,
            column: 78
          }
        }],
        line: 147
      },
      "4": {
        loc: {
          start: {
            line: 173,
            column: 15
          },
          end: {
            line: 173,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 173,
            column: 15
          },
          end: {
            line: 173,
            column: 30
          }
        }, {
          start: {
            line: 173,
            column: 34
          },
          end: {
            line: 173,
            column: 51
          }
        }, {
          start: {
            line: 173,
            column: 55
          },
          end: {
            line: 173,
            column: 74
          }
        }],
        line: 173
      },
      "5": {
        loc: {
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 181,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 175,
            column: 4
          },
          end: {
            line: 181,
            column: 5
          }
        }, {
          start: {
            line: 177,
            column: 11
          },
          end: {
            line: 181,
            column: 5
          }
        }],
        line: 175
      },
      "6": {
        loc: {
          start: {
            line: 177,
            column: 11
          },
          end: {
            line: 181,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 177,
            column: 11
          },
          end: {
            line: 181,
            column: 5
          }
        }, {
          start: {
            line: 179,
            column: 11
          },
          end: {
            line: 181,
            column: 5
          }
        }],
        line: 177
      },
      "7": {
        loc: {
          start: {
            line: 179,
            column: 11
          },
          end: {
            line: 181,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 179,
            column: 11
          },
          end: {
            line: 181,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 179
      },
      "8": {
        loc: {
          start: {
            line: 232,
            column: 6
          },
          end: {
            line: 232,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 232,
            column: 42
          },
          end: {
            line: 232,
            column: 63
          }
        }, {
          start: {
            line: 232,
            column: 66
          },
          end: {
            line: 232,
            column: 89
          }
        }],
        line: 232
      },
      "9": {
        loc: {
          start: {
            line: 232,
            column: 6
          },
          end: {
            line: 232,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 232,
            column: 6
          },
          end: {
            line: 232,
            column: 19
          }
        }, {
          start: {
            line: 232,
            column: 23
          },
          end: {
            line: 232,
            column: 39
          }
        }],
        line: 232
      },
      "10": {
        loc: {
          start: {
            line: 236,
            column: 9
          },
          end: {
            line: 240,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 236,
            column: 9
          },
          end: {
            line: 236,
            column: 14
          }
        }, {
          start: {
            line: 237,
            column: 10
          },
          end: {
            line: 239,
            column: 30
          }
        }],
        line: 236
      },
      "11": {
        loc: {
          start: {
            line: 241,
            column: 9
          },
          end: {
            line: 241,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 241,
            column: 9
          },
          end: {
            line: 241,
            column: 17
          }
        }, {
          start: {
            line: 241,
            column: 21
          },
          end: {
            line: 241,
            column: 76
          }
        }],
        line: 241
      },
      "12": {
        loc: {
          start: {
            line: 250,
            column: 21
          },
          end: {
            line: 250,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 250,
            column: 21
          },
          end: {
            line: 250,
            column: 31
          }
        }, {
          start: {
            line: 250,
            column: 36
          },
          end: {
            line: 250,
            column: 51
          }
        }, {
          start: {
            line: 250,
            column: 55
          },
          end: {
            line: 250,
            column: 71
          }
        }],
        line: 250
      },
      "13": {
        loc: {
          start: {
            line: 254,
            column: 16
          },
          end: {
            line: 254,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 254,
            column: 16
          },
          end: {
            line: 254,
            column: 25
          }
        }, {
          start: {
            line: 254,
            column: 29
          },
          end: {
            line: 254,
            column: 33
          }
        }],
        line: 254
      },
      "14": {
        loc: {
          start: {
            line: 262,
            column: 17
          },
          end: {
            line: 262,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 262,
            column: 17
          },
          end: {
            line: 262,
            column: 24
          }
        }, {
          start: {
            line: 262,
            column: 28
          },
          end: {
            line: 262,
            column: 30
          }
        }],
        line: 262
      },
      "15": {
        loc: {
          start: {
            line: 265,
            column: 9
          },
          end: {
            line: 265,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 265,
            column: 9
          },
          end: {
            line: 265,
            column: 21
          }
        }, {
          start: {
            line: 265,
            column: 25
          },
          end: {
            line: 265,
            column: 63
          }
        }],
        line: 265
      },
      "16": {
        loc: {
          start: {
            line: 273,
            column: 41
          },
          end: {
            line: 273,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 273,
            column: 41
          },
          end: {
            line: 273,
            column: 62
          }
        }, {
          start: {
            line: 273,
            column: 66
          },
          end: {
            line: 273,
            column: 75
          }
        }],
        line: 273
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a256b29bbb9382fb3851d0135201bbc1ee33579b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_dt62d3vlu = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_dt62d3vlu();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import React from 'react';
import { colors, fontSizesNamed, fontSizesNamedWithUnits, fontWeights, radii, space } from '../theme/eero';
import { ErrorPrompt } from '../complex/ErrorPrompt';
var ASSERT_NOT_NULL_ERROR = (cov_dt62d3vlu().s[0]++, 'This field cannot be empty.');
export var UNSAFE_SingleLineInputWrapper = (cov_dt62d3vlu().s[1]++, _styled("div", process.env.NODE_ENV === "production" ? {
  target: "eyst4zx3"
} : {
  target: "eyst4zx3",
  label: "UNSAFE_SingleLineInputWrapper"
})("width:", function (props) {
  cov_dt62d3vlu().f[0]++;
  cov_dt62d3vlu().s[2]++;
  return props.unboundedWidth ? (cov_dt62d3vlu().b[0][0]++, '100%') : (cov_dt62d3vlu().b[0][1]++, '350px');
}, ";@media (max-width: 768px){width:100%;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
export var UNSAFE_LabelTitle = (cov_dt62d3vlu().s[3]++, _styled("div", process.env.NODE_ENV === "production" ? {
  target: "eyst4zx2"
} : {
  target: "eyst4zx2",
  label: "UNSAFE_LabelTitle"
})("font-weight:", fontWeights.bold, ";font-size:", function (props) {
  cov_dt62d3vlu().f[1]++;
  cov_dt62d3vlu().s[4]++;

  if (props.inputLabelSize === 'large') {
    cov_dt62d3vlu().b[1][0]++;
    cov_dt62d3vlu().s[5]++;
    return fontSizesNamed.s2;
  } else {
    cov_dt62d3vlu().b[1][1]++;
    cov_dt62d3vlu().s[6]++;

    if (props.inputLabelSize === 'medium') {
      cov_dt62d3vlu().b[2][0]++;
      cov_dt62d3vlu().s[7]++;
      return fontSizesNamedWithUnits.s1;
    } else {
      cov_dt62d3vlu().b[2][1]++;
    }
  }

  cov_dt62d3vlu().s[8]++;
  return fontSizesNamedWithUnits.s0;
}, ";text-align:left;color:", function (props) {
  cov_dt62d3vlu().f[2]++;
  cov_dt62d3vlu().s[9]++;
  return props.disabled ? (cov_dt62d3vlu().b[3][0]++, colors.neutrals70) : (cov_dt62d3vlu().b[3][1]++, colors.neutrals100);
}, ";margin-bottom:", space[3], "px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
export var UNSAFE_LabelSubtitle = (cov_dt62d3vlu().s[10]++, _styled("div", process.env.NODE_ENV === "production" ? {
  target: "eyst4zx1"
} : {
  target: "eyst4zx1",
  label: "UNSAFE_LabelSubtitle"
})("margin-bottom:", space[3], "px;font-weight:normal;font-size:", fontSizesNamedWithUnits.s0, ";text-align:left;color:", colors.neutrals90, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
export var UNSAFE_InvalidStyle = (cov_dt62d3vlu().s[11]++, /*#__PURE__*/css("border:2px solid ", colors.red50, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UNSAFE_InvalidStyle;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
export var UNSAFE_SingleInput = (cov_dt62d3vlu().s[12]++, _styled("input", process.env.NODE_ENV === "production" ? {
  target: "eyst4zx0"
} : {
  target: "eyst4zx0",
  label: "UNSAFE_SingleInput"
})("width:100%;height:56px;font-size:", fontSizesNamedWithUnits.s1, ";text-align:", function (props) {
  cov_dt62d3vlu().f[3]++;
  cov_dt62d3vlu().s[13]++;
  return props.alignText;
}, ";border:1px solid ", colors.neutrals40, ";box-sizing:border-box;padding:10px 12px;", function (props) {
  cov_dt62d3vlu().f[4]++;
  cov_dt62d3vlu().s[14]++;
  return (cov_dt62d3vlu().b[4][0]++, props.isInvalid) && (cov_dt62d3vlu().b[4][1]++, !props.isCtaInput) && (cov_dt62d3vlu().b[4][2]++, UNSAFE_InvalidStyle);
}, ";border-radius:", function (props) {
  cov_dt62d3vlu().f[5]++;
  cov_dt62d3vlu().s[15]++;

  if (props.designStyle === 'rounded') {
    cov_dt62d3vlu().b[5][0]++;
    cov_dt62d3vlu().s[16]++;
    return radii.rounded;
  } else {
    cov_dt62d3vlu().b[5][1]++;
    cov_dt62d3vlu().s[17]++;

    if (props.designStyle === 'squared') {
      cov_dt62d3vlu().b[6][0]++;
      cov_dt62d3vlu().s[18]++;
      return radii.squared;
    } else {
      cov_dt62d3vlu().b[6][1]++;
      cov_dt62d3vlu().s[19]++;

      if (props.designStyle === 'rounded-square') {
        cov_dt62d3vlu().b[7][0]++;
        cov_dt62d3vlu().s[20]++;
        return radii.roundedSquare;
      } else {
        cov_dt62d3vlu().b[7][1]++;
      }
    }
  }
}, ";&:disabled{background:", colors.neutrals10, ";cursor:not-allowed;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
/**
 * @deprecated Use core/Input instead
 */

export var UNSAFE_SingleLineInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(UNSAFE_SingleLineInput, _React$PureComponent);

  var _super = _createSuper(UNSAFE_SingleLineInput);

  function UNSAFE_SingleLineInput() {
    var _this;

    _classCallCheck(this, UNSAFE_SingleLineInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChange", (cov_dt62d3vlu().s[25]++, function (e) {
      cov_dt62d3vlu().f[7]++;
      cov_dt62d3vlu().s[26]++;
      e.preventDefault();
      cov_dt62d3vlu().s[27]++;

      _this.props.onChange(_this.props.name, (cov_dt62d3vlu().b[16][0]++, e.currentTarget.value) || (cov_dt62d3vlu().b[16][1]++, undefined));
    }));

    return _this;
  }

  _createClass(UNSAFE_SingleLineInput, [{
    key: "render",
    value: function render() {
      cov_dt62d3vlu().f[6]++;

      var _ref = (cov_dt62d3vlu().s[22]++, this.props),
          id = _ref.id,
          alignText = _ref.alignText,
          ariaLabel = _ref.ariaLabel,
          ariaLabelledby = _ref.ariaLabelledby,
          assertNotNull = _ref.assertNotNull,
          autoComplete = _ref.autoComplete,
          autoFocus = _ref.autoFocus,
          className = _ref.className,
          content = _ref.content,
          designStyle = _ref.designStyle,
          disabled = _ref.disabled,
          hasError = _ref.hasError,
          inputLabelSize = _ref.inputLabelSize,
          inputType = _ref.inputType,
          inputName = _ref.inputName,
          name = _ref.name,
          onBlur = _ref.onBlur,
          onFocus = _ref.onFocus,
          onKeyDown = _ref.onKeyDown,
          placeholder = _ref.placeholder,
          required = _ref.required,
          title = _ref.title,
          subtitle = _ref.subtitle,
          unboundedWidth = _ref.unboundedWidth,
          isCtaInput = _ref.isCtaInput;

      var errorMessage = (cov_dt62d3vlu().s[23]++, (cov_dt62d3vlu().b[9][0]++, assertNotNull) && (cov_dt62d3vlu().b[9][1]++, _isEmpty(content)) ? (cov_dt62d3vlu().b[8][0]++, ASSERT_NOT_NULL_ERROR) : (cov_dt62d3vlu().b[8][1]++, this.props.errorMessage));
      cov_dt62d3vlu().s[24]++;
      return jsx(UNSAFE_SingleLineInputWrapper, {
        unboundedWidth: unboundedWidth
      }, (cov_dt62d3vlu().b[10][0]++, title) && (cov_dt62d3vlu().b[10][1]++, jsx(UNSAFE_LabelTitle, {
        inputLabelSize: inputLabelSize,
        disabled: !!disabled
      }, title)), (cov_dt62d3vlu().b[11][0]++, subtitle) && (cov_dt62d3vlu().b[11][1]++, jsx(UNSAFE_LabelSubtitle, null, subtitle)), jsx(UNSAFE_SingleInput, {
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        className: className,
        autoComplete: autoComplete,
        designStyle: designStyle,
        alignText: alignText,
        isInvalid: (cov_dt62d3vlu().b[12][0]++, !!hasError) || (cov_dt62d3vlu().b[12][1]++, !!assertNotNull) && (cov_dt62d3vlu().b[12][2]++, _isEmpty(content)) // eslint-disable-next-line jsx-a11y/no-autofocus
        ,
        autoFocus: autoFocus,
        disabled: disabled,
        name: (cov_dt62d3vlu().b[13][0]++, inputName) || (cov_dt62d3vlu().b[13][1]++, name),
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onChange: this.handleChange,
        placeholder: placeholder,
        required: required,
        type: inputType,
        value: (cov_dt62d3vlu().b[14][0]++, content) || (cov_dt62d3vlu().b[14][1]++, ''),
        isCtaInput: isCtaInput
      }), (cov_dt62d3vlu().b[15][0]++, errorMessage) && (cov_dt62d3vlu().b[15][1]++, jsx(ErrorPrompt, {
        message: errorMessage
      })), this.props.children);
    }
  }]);

  return UNSAFE_SingleLineInput;
}((React.PureComponent));

_defineProperty(UNSAFE_SingleLineInput, "defaultProps", (cov_dt62d3vlu().s[21]++, {
  alignText: 'left',
  designStyle: 'rounded-square',
  inputLabelSize: 'small',
  inputType: 'text',
  unboundedWidth: false
}));